import React from 'react';
import { Calendar, DollarSign, Tag, MapPin, TrendingUp, Percent, Layers, Monitor, History } from 'lucide-react';

export const PromocaoCard = ({ promocao, selecionada, onSelecionar, onViewHistory }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case '1':
        return { 
          bg: 'bg-emerald-50', 
          text: 'text-emerald-700', 
          border: 'border-emerald-200',
          dot: 'bg-emerald-500',
          glow: 'shadow-emerald-100',
          label: 'Ativa'
        };
      case '0':
        return { 
          bg: 'bg-amber-50', 
          text: 'text-amber-700', 
          border: 'border-amber-200',
          dot: 'bg-amber-500',
          glow: 'shadow-amber-100',
          label: 'Pausada'
        };
      case '2':
        return { 
          bg: 'bg-rose-50', 
          text: 'text-rose-700', 
          border: 'border-rose-200',
          dot: 'bg-rose-500',
          glow: 'shadow-rose-100',
          label: 'Finalizada'
        };
      default:
        return { 
          bg: 'bg-slate-50', 
          text: 'text-slate-700', 
          border: 'border-slate-200',
          dot: 'bg-slate-500',
          glow: 'shadow-slate-100',
          label: 'Desconhecido'
        };
    }
  };

  const formatCurrency = (value) => {
    if (value >= 1000000) {
      return `R$ ${(value / 1000000).toFixed(1)}M`;
    } else if (value >= 1000) {
      return `R$ ${(value / 1000).toFixed(0)}k`;
    }
    return `R$ ${value.toLocaleString('pt-BR')}`;
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch {
      return dateString;
    }
  };

  const statusConfig = getStatusConfig(promocao.Status);
  const isModified = promocao.modified;
  const novoBudget = promocao.novoBudget;
  const tipoSegmentacao = promocao.tipoSegmentacao;
  const budgetAtual = parseFloat(promocao.OrcamentoPromocao || '0');

  return (
    <div
      onClick={() => onSelecionar(promocao)}
      className={`
        group relative overflow-hidden cursor-pointer
        transition-all duration-300 ease-out
        hover:shadow-xl hover:-translate-y-1
        ${selecionada 
          ? 'ring-2 ring-blue-500 ring-offset-2 shadow-lg shadow-blue-100' 
          : 'hover:shadow-slate-200/80'
        }
        ${isModified ? 'bg-gradient-to-br from-emerald-50/50 to-white' : 'bg-white'}
        rounded-xl border shadow-sm
      `}
    >
      
      {/* Accent line */}
      <div className={`
        absolute top-0 left-0 w-1 h-full transition-all duration-300
        ${selecionada 
          ? 'bg-gradient-to-b from-blue-500 to-blue-600' 
          : isModified 
            ? 'bg-gradient-to-b from-emerald-400 to-emerald-500'
            : 'bg-gradient-to-b from-slate-200 to-slate-300 group-hover:from-blue-400 group-hover:to-blue-500'
        }
      `} />

      {/* Modified indicator */}
      

      <div className="p-5 pl-6 space-y-4">
        {/* Header */}
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="font-semibold text-slate-900 text-lg leading-tight group-hover:text-blue-700 transition-colors duration-200" title={promocao.Nome}>
                {promocao.Nome}
              </h3>
              {/* Badge de Benefício */}
              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs font-semibold">
                <Percent className="h-3 w-3" />
                {parseFloat(promocao.BeneficioValor).toFixed(2)}%
              </span>
            </div>
            <div className="flex items-center gap-2 mt-1.5">
              <Tag className="h-3.5 w-3.5 text-slate-400" />
              <span className="text-sm text-slate-500 font-medium">ID {promocao.IDRegraPromocao}</span>
            </div>
          </div>

          {/* History Button */}
          { /*
          {onViewHistory && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onViewHistory(promocao.IDRegraPromocao);
              }}
              className="p-2 hover:bg-purple-50 text-purple-600 rounded-lg transition-colors shrink-0"
              title="Ver histórico de alterações"
            >
              <History className="h-5 w-5" />
            </button>
          )}
*/}
          {/* Status Badge */}
          {/*<div className={`
              ${statusConfig.bg} ${statusConfig.text} ${statusConfig.border}
              px-3 py-1.5 font-medium text-xs shrink-0
              shadow-sm ${statusConfig.glow} rounded-full border
            `}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${statusConfig.dot} mr-2 animate-pulse`} />
            {statusConfig.label}
          </div>*/}
        </div>

        {/* Tags Row */}
        <div className="flex flex-wrap gap-2">
          <div className="bg-orange-100 text-orange-700 hover:bg-orange-100 border-0 font-medium px-2 py-1 rounded-full text-xs">
            {promocao.AgrupamentoPromocao}
          </div>
          
          {tipoSegmentacao && (
            <div className="bg-indigo-100 text-indigo-700 hover:bg-indigo-100 border-0 font-medium px-2 py-1 rounded-full text-xs">
              {tipoSegmentacao}
            </div>
          )}
        </div>

        {/* Budget highlight */}
        {(novoBudget || budgetAtual > 0) && (
          <div className={`grid ${(budgetAtual > 0 && novoBudget) ? 'grid-cols-2' : 'grid-cols-1'} gap-3`}>
            {/* Budget - mostra novo budget se configurado, ou budget atual se existir */}
            {novoBudget && (
              <div className="flex items-center gap-3 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-200">
                <div className="p-2 bg-white rounded-lg shadow-sm">
                  <DollarSign className="h-4 w-4 text-blue-600" />
                </div>
                <div>
                  <p className="text-xs text-blue-600 font-medium">Novo Budget</p>
                  <p className="text-lg font-bold text-blue-700">{formatCurrency(novoBudget)}</p>
                </div>
              </div>
            )}
            {budgetAtual > 0 && (
              <div className="flex items-center gap-3 p-3 bg-gradient-to-r from-slate-50 to-gray-50 rounded-xl border border-slate-200">
                <div className="p-2 bg-white rounded-lg shadow-sm">
                  <DollarSign className="h-4 w-4 text-slate-600" />
                </div>
                <div>
                  <p className="text-xs text-slate-600 font-medium">Budget</p>
                  <p className="text-lg font-bold text-slate-700">{formatCurrency(budgetAtual)}</p>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Dates Footer */}
        <div className="flex items-center justify-between pt-3 border-t border-slate-100">
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <Calendar className="h-3.5 w-3.5" />
            <span className="font-medium">{formatDate(promocao.DataHoraInicio)}</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-8 h-px bg-gradient-to-r from-slate-200 to-slate-300" />
            <TrendingUp className="h-3.5 w-3.5 text-slate-400" />
            <div className="w-8 h-px bg-gradient-to-r from-slate-300 to-slate-200" />
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <span className="font-medium">{formatDate(promocao.DataHoraFim)}</span>
            <Calendar className="h-3.5 w-3.5" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromocaoCard;
